import { Link } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import styles from './AboutUs.module.css';

const AppContent: React.FC = () => {
  return (
    <Paper className={styles.content}>
      <div className={styles.container}>
        <div className={styles.textBlock}>
          <Typography variant="h5" component="h2" gutterBottom>
            About Code Savvy
          </Typography>
          <Typography variant="body1" paragraph>
            Code Savvy is on a mission to empower all students and educators with knowledge, skills,
            and support to create with technology. We work towards this goal by creating
            opportunities for hands-on experiences that inspire all learners to transform the
            future.
          </Typography>
          <Typography variant="body1" paragraph>
            Code Savvy is a non-profit organization that empowers kids and educators to become more
            tech savvy through creative educational programs and services. We incubate and support
            community-based programs that champion gender and ethnic diversity in tech. Our training
            for K-12 educators emphasizes equitable teaching practices that interrupt and counteract
            gender and racial gaps in computer science (CS).
          </Typography>
          <Typography variant="body1" paragraph>
            Code Savvy is a central resource for local advocates and champions for the advancement
            of K-12 computer science learning opportunities. Through its connections and vision, it
            activates programs and services that give real-world coding experience to youth who
            represent backgrounds traditionally underrepresented in computer science.
          </Typography>
        </div>
        <div className={styles.textBlock}>
          <Typography variant="h5" component="h2">
            Code Savvy’s Educator Programs include:
          </Typography>
          <ul>
            <Typography variant="body1" component="li">
              <strong>MN Coding in the Classroom Leadership Cohort</strong> - Ongoing, statewide
              training for K-12 CS education. K-12 and community educators meet monthly to explore,
              collaborate and share information about CS education while developing resources for
              integrating CS into MN classrooms and other learning environments, and providing
              training for other educators in their unique geographic locations.
            </Typography>
            <Typography variant="body1" component="li">
              <strong>MN Codes Summit</strong> - Minnesota’s K-12 CS education conference draws
              educators, administrators, community education staff, lawmakers, and other
              stakeholders to collaborate and share ideas for expanding CS ed in MN.
            </Typography>
            <Typography variant="body1" component="li">
              <strong>Scratch Camp for Educators</strong> - A hands-on training focused on creative
              CS education using Scratch, a powerful coding language for creating games, stories and
              animations.
            </Typography>
            <Typography variant="body1" component="li">
              <strong>MN Codes Professional Trainers Program</strong> - Provides teachers, schools,
              and districts with customizable professional development opportunities around CS
              education.
            </Typography>
          </ul>
        </div>
        <div className={styles.textBlock}>
          <Typography variant="h5" component="h2" gutterBottom>
            File a bug/provide feedback:
          </Typography>
          <Typography variant="body1" paragraph>
            We welcome your feedback! If you have an idea, feature request, or would like to file a
            bug, please fill out our{' '}
            <Link
              href="https://forms.gle/qVW61k6Ufs4nonXcA"
              target="_blank"
              rel="noopener noreferrer"
            >
              feedback form.
            </Link>
          </Typography>
        </div>
      </div>
    </Paper>
  );
};

export default AppContent;
